import { useRequest } from "ahooks";
import {
  cancelPushNotif,
  pushNotificationUnVerifyAccount,
  pushNotificationVerifyAccount,
} from "@/shahrzad-assets/shared-api/api";
import { getAccessToken, getRefreshToken } from "@/shahrzad-assets/shared-constants/localstorage";
import {
  getBrowserName,
  getClientVersion,
  getDeviceBrand,
  getDeviceModel,
  getOS,
  getOSVersion,
} from "../shared-utils/getUserDevice";
import { UserInfoContext } from "../shared-contexts/UserInfoContext";
import { useContext } from "react";
import { parseJwt } from "../shared-utils/jwtParser";

export const usePushNotification = () => {
  const { userInfo } = useContext(UserInfoContext);
  let osName = getOS();
  let osVersion = getOSVersion();
  let deviceModel = getBrowserName();
  let deviceBrand = getDeviceBrand();
  let clientVersion = getClientVersion();

   const { runAsync: fetchPushNotifVerify, loading: pushNotificationVerifyLoading } =
    useRequest(pushNotificationVerifyAccount, {
      manual: true,

      onSuccess(data: any) {},
      onError(error: any) {},
    });

    const { runAsync: fetchCancelNotif, loading: fetchCancelNotifLoading } =
    useRequest(cancelPushNotif, {
      manual: true,

      onSuccess(data: any) {},
      onError(error: any) {},
    });


  const {
    runAsync: fetchPushNotifUnVerify,
    loading: pushNotificationUnVerifyLoading,
  } = useRequest(pushNotificationUnVerifyAccount, {
    manual: true,
    onSuccess(data: any) {},
    onError(error: any) {},
  });
  

  const addPushNotificationUnVerified = (fcm_token) => {
 
      return new Promise<void>((resolve, reject) => {
        try{
        const data = {
          fcm_token: fcm_token,
          os_name: osName,
          os_version: osVersion,
          device_model: deviceModel,
          device_brand: deviceBrand,
          client_version: clientVersion,
        };
        if (getAccessToken() === null) {
          return fetchPushNotifUnVerify(data).finally(()=>{
            resolve()
          });
        } else {
          return fetchPushNotifVerify({
            ...data,
            email: userInfo.sub,
            phone_number:userInfo.Mobile,
          }).finally(()=>{
            resolve()
          });
        }
      }
      catch{
        resolve()
      }
      })
  };

  const addPushNotificationForLogin=(fcmToken:string,accessToken:string)=>{
    return new Promise<void>((resolve, reject) => {
      const data = {
        fcm_token: fcmToken,
        os_name: osName,
        os_version: osVersion,
        device_model: deviceModel,
        device_brand: deviceBrand,
        client_version: clientVersion,
      };
        let userData=parseJwt(accessToken)
         fetchPushNotifVerify({
          ...data,
          email: userData?.sub,
          phone_number:userData?.Mobile,
        }).then(()=>{
          resolve()
        }).catch(()=>{
          reject()
        })
    })
  }


  return {
    addPushNotificationUnVerified,
    fetchPushNotifUnVerify,
    fetchPushNotifVerify,
    pushNotificationUnVerifyLoading,
    pushNotificationVerifyLoading,
    addPushNotificationForLogin,
    fetchCancelNotif
  };
};

export default usePushNotification;
